/* Тип зоны доставки */

export default class PolygonType {
  static get Green () {
    return 'green'
  }

  static get Yellow () {
    return 'yellow'
  }

  static get Red () {
    return 'red'
  }

  static getName (enumValue) {
    switch (enumValue) {
      case PolygonType.Green:
        return 'Зеленая'

      case PolygonType.Yellow:
        return 'Желтая'

      case PolygonType.Red:
        return 'Красная'

      default:
        return enumValue
    }
  }
}
